import { createSlice } from '@reduxjs/toolkit';

import setAllowRotateReducer from './reducer/setAllowRotateReducer';
import setGapMmReducer from './reducer/setGapMmReducer';
import { GangSheetState } from './types';

export const gangSheetInitialState: GangSheetState = {
  gapMm: undefined,
  allowRotate: undefined,
};

export const slice = createSlice({
  name: 'gangSheet',
  initialState: gangSheetInitialState,
  reducers: {
    setGapMmAction: setGapMmReducer,
    setAllowRotateAction: setAllowRotateReducer,
  },
});

export const { setGapMmAction, setAllowRotateAction } = slice.actions;

const gangSheetReducer = slice.reducer;

export default gangSheetReducer;
